import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import { ApiService } from '@libs-uuif/shared/api-service';
import { currentUserKey } from '@/shared/msw-constants';
import { envCongif } from '@/shared/env.config';

export interface DattoAutotaskStoreState {
  autotaskIntegrationTemp: any;
  autotaskIntegration: any;
  syncDetails: any;
  employees: object[];
  submitted: boolean;
  modalClosed: boolean;
  tenantsData: any;
}

const apiObject = new ApiService(`${envCongif.thirtParty_url}`);
// const postIntegrationConfig = '/save_integration_config';
// const checkIntegrationConfig = '/check_integration_config';

export default {
  state: {
    autotaskIntegration: {
      apiUserName: '',
      apiPassword: '',
      id: '',
      userList: [],
      userType: '',
      addAdditions: false,
    },
    autotaskIntegrationTemp: {},
    syncDetails: {
      api_user_name: '',
      last_sync: '',
      last_sync_wo_errors: '',
      last_sync_details: [],
    },
    submitted: false,
    employees: [],
    tenantsData: [],
    modalClosed: false, // For calling refresh data if config stored successfully
  },
  mutations: {
    setAutotaskIntegrationDetails(state, payload) {
      // const id = JSON.parse(localStorage.getItem(currentUserKey) as any).userId;
      state.autotaskIntegrationTemp = Object.assign({}, payload);
      state.autotaskIntegration = payload;
    },
    setSyncDetails(state, payload) {
      state.syncDetails = payload;
    },
    updateAutotaskIntegrationDetails(state, updatedObj) {
      state.autotaskIntegration[updatedObj.key] = updatedObj.value;
    },
    updateEmployees(state, employees = []) {
      state.employees = JSON.parse(JSON.stringify(employees)); // to set the employees
    },
    updateSubmitted(state, submitted) {
      state.submitted = submitted;
    },
    setTenantsData(state, payload) {
      state.tenantsData = payload;
    },
  },
  actions: {
    // Configuration of Autotask api's
    // tslint:disable-next-line:no-unused
    fetchAutotaskIntegrationDetails(context: ActionContext<DattoAutotaskStoreState, RootStoreState>) {
      // context.commit('startLoading', null, { root: true });
      /* tslint:disable-next-line */
      const userId: string = JSON.parse(localStorage.getItem(currentUserKey) as any).userId.toString().toLowerCase() || '';
      const getAutotaskServerDetails = `/get_integration_config/${userId}?integration_name=autotask`;
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.get(getAutotaskServerDetails);
    },
    saveAutotaskIntegrationDetails(context: ActionContext<DattoAutotaskStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const getAutotaskServerDetails = '/save_integration_config?integration_name=autotask';
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.post(getAutotaskServerDetails, context.state.autotaskIntegration);
    },
    checkIntegrationConfig(context: ActionContext<DattoAutotaskStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      /* tslint:disable-next-line */
      const userId: string = JSON.parse(localStorage.getItem(currentUserKey) as any).userId.toString().toLowerCase() || '';
      context.state.autotaskIntegration.id = userId;
      const checkForIntegrationConfig = '/check_integration_config?integration_name=autotask';
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.post(checkForIntegrationConfig,  context.state.autotaskIntegration);
    },
    // to get last sync details
    // tslint:disable-next-line:no-unused
    getSyncDetails(context: ActionContext<DattoAutotaskStoreState, RootStoreState>) {
      // context.commit('startLoading', null, { root: true });
      /* tslint:disable-next-line */
      const userId: string = (JSON.parse(localStorage.getItem(currentUserKey) as any).userId.toString().toLowerCase()) || '';
      const getSyncDetails = `/get_sync_details/${userId}?integration_name=autotask`;
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.get(getSyncDetails);
    },
    // For table data update
    postTenantDetails(context: ActionContext<DattoAutotaskStoreState, RootStoreState>, tenantData) {
      context.commit('startLoading', null, { root: true });
      /* tslint:disable-next-line */
      const userId: string = JSON.parse(localStorage.getItem(currentUserKey) as any).userId.toString().toLowerCase() || '';
      const postTenantData = `/save_sync_details/${userId}?integration_name=autotask`;
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.post(postTenantData, JSON.stringify(tenantData));
    },
    // called the below two api on sync now
    getSyncJobStatus(context: ActionContext<DattoAutotaskStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      /* tslint:disable-next-line */
      const userId: string = JSON.parse(localStorage.getItem(currentUserKey) as any).userId.toString().toLowerCase() || '';
      const getJobStatus = `/get_job_state/${userId}?integration_name=autotask`;
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.get(getJobStatus);
    },
    startSyncNow(context: ActionContext<DattoAutotaskStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      /* tslint:disable-next-line */
      const userId: string = JSON.parse(localStorage.getItem(currentUserKey) as any).userId.toString().toLowerCase() || '';
      const getSyncNowStatus = `/sync_now/${userId}?integration_name=autotask`;
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.post(getSyncNowStatus, {});
    },
    // get copmpany list
    // tslint:disable-next-line:no-unused
    getCompanyList(context: ActionContext<DattoAutotaskStoreState, RootStoreState>, payload) {
      // context.commit('startLoading', null, { root: true });
      /* tslint:disable-next-line */
      const userId: string = JSON.parse(localStorage.getItem(currentUserKey) as any).userId.toString().toLowerCase() || '';
      const getCompanyList = `/get_company_list/${userId}?integration_name=autotask&isForced=${payload.isForced}`;
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.get(getCompanyList);
    },
    // Tenant's sync staus( Used along with table )
    getTenantSyncStatus(context: ActionContext<DattoAutotaskStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      /* tslint:disable-next-line */
      const userId: string = JSON.parse(localStorage.getItem(currentUserKey) as any).userId.toString().toLowerCase() || '';
      const getTenantSyncStatus = `/get_tenant_sync_status/${userId}?integration_name=autotask`;
      apiObject.setAuth({ type: 'auth-token', authToken: JSON.parse(localStorage.getItem(currentUserKey) as any).token });
      return apiObject.get(getTenantSyncStatus);
    },
    setSyncDetailsToStore({ commit }, payload) {
      commit('setSyncDetails', payload);
    },
  },
  getters: {
    getAutotaskIntegrationDetails: state => state.autotaskIntegration,
    getAutotaskIntegrationDetailsTemp: state => state.autotaskIntegrationTemp,
    getSyncDetails: state => state.syncDetails,
    getEmployees: state => state.employees,
    getSubmitted: state => state.submitted,
    getModalClosed: state => state.modalClosed,
    getTenantsData: state => state.tenantsData,
  },
  namespaced: true,
} as Module<DattoAutotaskStoreState, RootStoreState>;
